export enum DocsFieldsEnum {
    /**
     * CNH: número do documento
     */
    CNH_NUMBER = 'cnh-number',

    /**
     * CNH: UF do órgão emissor
     */
    CNH_UF_EMISSOR = 'cnh-emissor',

    /**
     * CNH: data de emissão
     */
    CNH_DATA_EMISSAO = 'cnh-data-emissao',

    /**
     * CNH: código de segurança
     */
    CNH_SEGURANCA = 'cnh-seguranca',

    /**
     * CNH: data de validade do documento
     */
    CNH_DATA_VALIDADE = 'cnh-data-validade',

    /**
     * RG: órgão emissor
     */
    RG_EMISSOR = 'rg-emissor',

    /**
     * RG: UF do órgão emissor
     */
    RG_UF_EMISSOR = 'rg-uf-emissor',

    /**
     * RG: número do documento
     */
    RG_NUMBER = 'rg-number',

    /**
     * RG: data de expedição
     */
    RG_DATA_EXPEDICAO = 'rg-data',


    /**
     * CNH: Nome presente no documento de identificação 
     */
    CNH_NOME = 'cnh-nome',

    /**
     * RG: Nome presente no documento de identificação 
     */
    RG_NOME = 'rg-nome'
}